import React from "react";
import { X } from "lucide-react";
import MDEditor from "@uiw/react-md-editor";

const ViewNoteModal = ({ isOpen, onClose, problem }) => {
  if (!isOpen || !problem) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" 
        onClick={onClose} 
      />

      {/* Modal Dialog */}
      <div className="relative w-full max-w-3xl bg-white rounded-2xl shadow-xl flex flex-col max-h-[90vh]">
        
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-slate-50/50 rounded-t-2xl shrink-0">
          <h2 className="text-lg font-semibold text-slate-800">
            Notes: <span className="text-blue-600 font-bold">{problem.title}</span>
          </h2>
          <button 
            onClick={onClose} 
            className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Markdown Viewer */}
        <div className="flex-1 overflow-y-auto p-6 bg-white rounded-b-2xl">
          <div data-color-mode="light">
            <MDEditor.Markdown 
              source={problem.note || "*No notes added for this problem yet.*"} 
              style={{ background: 'transparent', color: '#334155' }}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default ViewNoteModal;